import { render, staticRenderFns } from "./StepFormulario.vue?vue&type=template&id=aced67fc"
import script from "./StepFormulario.vue?vue&type=script&lang=js"
export * from "./StepFormulario.vue?vue&type=script&lang=js"
import style0 from "./StepFormulario.vue?vue&type=style&index=0&id=aced67fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports